export const OrderStatus = {
  PLACED: 'Placed',
  ACKNOWLEDGED: 'Acknowledged',
  FOOD_READY: 'Food Ready',
  DISPATCHED: 'Dispatched',

  // Terminal
  MODIFIED: 'Modified',
  CANCELLED: 'Cancelled',
  COMPLETED: 'Completed',
  CANCELLED_FOR_MODIFICATION: 'Cancelled-for-modification',

  // OMS
  EXPIRED: 'Expired',
  AWAITING_PAYMENT: 'AWAITING_PAYMENT',
  AWAITING_CHECKOUT: 'AWAITING_CHECKOUT',
} as const;

export type OrderStatusType = (typeof OrderStatus)[keyof typeof OrderStatus];
